import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, inject, signal } from '@angular/core';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { getAllRelationshipsSelector } from '@app/root-store/relationship-store/relationship.selector';
import { NetworkSetupService } from '@app/shared/services/network-setup/network-setup.service';
import { NetworkSetupTitleEnum } from '../../network-setup-enums';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'network-heading',
  templateUrl: './network-heading.component.html',
})
export class NetworkHeadingComponent implements OnInit, OnDestroy {
  @Output() optionValueEmitter = new EventEmitter();
  @Output() relationshipListEmitter = new EventEmitter();
  @Output() moveToNextStepEmitter = new EventEmitter<void>();
  @Input() currentUser;
  @Input() screenWidth;
  @Input() text;
  @Input() subText;
  @Input() listText;
  @Input() id;
  @Input() relationshipType;
  @Input() currentType;
  options = [{ value: 'Yes' }, { value: 'No' }];
  isLoading = signal(true);
  hasSelectedRelationships = signal(false);
  filteredList = [];
  allRelationshipList = [];
  subscription = new Subscription();
  showConnectCard = signal(false);

  private store = inject(Store);
  private networkSetupService = inject(NetworkSetupService);
  NetworkSetupTitleEnum = NetworkSetupTitleEnum;
  ngOnInit(): void {
    this.subscription.add(
      this.store.select(getAllRelationshipsSelector()).subscribe((res) => {
        this.allRelationshipList = res;
        this.getRelationshipList(this.text);
      })
    );
    this.subscription.add(this.networkSetupService.handleSetupDataCollection.subscribe((data) => {}));
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  handleConnectionsExisting(value) {}
  handleConnection(value) {}

  handleRelationShipCount(value) {}
  handlerRelationshipList(value) {
    this.relationshipListEmitter.emit(value);
  }
  handlerAllRelationshipList(value) {}

  getRelationshipList(type: NetworkSetupTitleEnum) {
    if (type.includes(NetworkSetupTitleEnum.FamilyUsers)) {
      const familyUsers = new Set([
        'husband',
        'wife',
        'spouse',
        'fiancee',
        'civil partner',
        'domestic partner',
        'son',
        'daughter',
        'step-son',
        'step-daughter',
        'child',
        'mother',
        'father',
        'step-mother',
        'step-father',
        'parent',
        'brother',
        'sister',
        'step-brother',
        'step-sister',
        'sibling',
        'grandmother',
        'grandfather',
        'step-grandmother',
        'step-grandfather',
        'great-grandparent',
        'great-great-grandparent',
        'great-grandfather',
        'great-grandmother',
        'great-great-grandfather',
        'great-great-grandmother',
        'grandparent',
        'grandson',
        'granddaughter',
        'step-grandson',
        'step-granddaughter',
        'great-grandchild',
        'great-great-grandchild',
        'great-grandson',
        'great-granddaughter',
        'great-great-grandson',
        'great-great-granddaughter',
        'grandchild',
        'legal dependent',
        'mother in-law',
        'father in-law',
        'sister in-law',
        'brother in-law',
        'son in-law',
        'daughter in-law',
        'in-law',
        'aunt',
        'great-aunt',
        'great-great-aunt',
        'paternal aunt',
        'maternal aunt',
        'great-paternal aunt',
        'great-maternal aunt',
        'great-great-paternal aunt',
        'great-great-maternal aunt',
        'uncle',
        'great-uncle',
        'great-great-uncle',
        'maternal uncle',
        'paternal uncle',
        'great-paternal uncle',
        'great-maternal uncle',
        'great-great-paternal uncle',
        'great-great-maternal uncle',
        'niece',
        'great-niece',
        'great-great-niece',
        'nephew',
        'great-nephew',
        'great-great-nephew',
        'cousin',
        'other family member',
        'significant other',
        'co-habitant',
      ]);
      this.filteredList = this.allRelationshipList?.filter((user) => familyUsers.has(user?.relationship_name?.toLowerCase()));
    } else if (type.includes(NetworkSetupTitleEnum.ProfessionalUsers)) {
      const professionalUsers = new Set([
        'professional - general',
        'professional - legal',
        'professional - financial',
        'professional - insurance',
        'professional - medical',
        'professional - assistant',
        'professional - other',
        'meta advisor',
        'advisor',
        'professional - staff',
      ]);

      this.filteredList = this.allRelationshipList.filter((user) => professionalUsers.has(user.relationship_name.toLowerCase()));
    }
    const exist = this.networkSetupService.handleSetupDataCollection.getValue().find((item) => item.step == this.id);
    if (this.filteredList.length > 0 || !!exist?.showConnectCard) {
      // if (this.filteredList.length > 0) {
      this.showConnectCard.set(true);
    } else {
      this.showConnectCard.set(false);
    }
    this.networkSetupService.handleSetupDataCollection.next([
      ...this.networkSetupService.handleSetupDataCollection.getValue().filter((item) => item?.step !== this.id),
      {
        step: this.id,
        filteredList: this.filteredList,
        showConnectCard: this.showConnectCard(),
      },
    ]);

    this.isLoading.set(false);
  }
}
